"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const complexData_1 = __importDefault(require("@powerednow/complexData/complexData"));
const modelLookup_1 = require("../modelLookup");
const entity_1 = __importDefault(require("./entity"));
const modelProperties_1 = __importDefault(require("./modelProperties"));
const constants = require('@powerednow/shared/constants').default;
// eslint-disable-next-line no-redeclare
class CisRate extends complexData_1.default {
    static get allowedAssociations() {
        return {};
    }
    static async getDefaultRateId(complexObject) {
        const registeredAddressCountryId = await (0, modelLookup_1.complexFindModel)('Company').getCompanyCountryId(complexObject);
        return (registeredAddressCountryId === constants.COUNTRY.IDS.UNITED_KINGDOM) ? constants.CIS.RATES.NET : constants.CIS.RATES.STANDARD;
    }
}
CisRate.Entity = entity_1.default;
CisRate.modelProperties = modelProperties_1.default;
exports.default = CisRate;
//# sourceMappingURL=../../../../src/models/cisRate/index.js.map